import { useEffect, useState } from "react";
import { useOrganizationList } from "@clerk/react";
import { mensagemDoErro } from "@/lib/painel/clerk-erros";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Spinner } from "@/components/ui/spinner";
import { CartaoEntrada } from "@/components/entrada/CartaoEntrada";

/**
 * Entra na clínica de que a pessoa JÁ é membro (convite aceito).
 *
 * A ativação é do lado do cliente porque a sessão é do navegador; o servidor
 * (page.tsx) só decide QUE é este o caso.
 */
export function AtivarClinica({ orgId, nome }: { orgId: string; nome: string }) {
  const { isLoaded, setActive } = useOrganizationList();
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoaded || !setActive) return;
    void (async () => {
      try {
        await setActive({ organization: orgId });
        window.location.href = "/conversas";
      } catch (e) {
        setErro(mensagemDoErro(e));
      }
    })();
  }, [isLoaded, setActive, orgId]);

  return (
    <CartaoEntrada rotulo="Convite" titulo={`Entrando em ${nome}…`}>
      {erro ? (
        <Alert variant="destructive">
          <AlertTitle>Não consegui abrir a clínica {nome}.</AlertTitle>
          <AlertDescription>{erro}</AlertDescription>
        </Alert>
      ) : (
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          <Spinner className="text-primary" /> Conectando você ao atendimento da clínica.
        </p>
      )}
    </CartaoEntrada>
  );
}
